'use strict';

var server = require('./server.js');



exports.FEDERATION_RESPONSE_MAX_SIZE = server.FEDERATION_RESPONSE_MAX_SIZE;
exports.Server = server.FederationServer;
//# sourceMappingURL=index.js.map
